import React, { useEffect } from "react";

/**
 * Unified Social Media Wall (YouTube, X/Twitter, Instagram, TikTok)
 * ✅ 100% Legal and Policy-Compliant
 * ✅ Responsive layout using TailwindCSS
 * ✅ Official embed methods (no iframe-block issues)
 */

export default function SocialMediaWall() {
  useEffect(() => {
    // Load Twitter embed script
    const twitterScript = document.createElement("script");
    twitterScript.src = "https://platform.twitter.com/widgets.js";
    twitterScript.async = true;
    document.body.appendChild(twitterScript);

    // Load Instagram embed script
    const instaScript = document.createElement("script");
    instaScript.src = "https://www.instagram.com/embed.js";
    instaScript.async = true;
    document.body.appendChild(instaScript);

    return () => {
      document.body.removeChild(twitterScript);
      document.body.removeChild(instaScript);
    };
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-4 grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      
      {/* YOUTUBE */}
      <div className="rounded-xl overflow-hidden shadow-md border border-slate-200 dark:border-slate-800">
        <iframe
          className="w-full aspect-video"
          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
          title="YouTube video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <div className="p-3 text-sm text-center text-slate-600 dark:text-slate-300">
          YouTube Video Embed
        </div>
      </div>

      {/* X / TWITTER */}
      <div className="rounded-xl overflow-hidden shadow-md border border-slate-200 dark:border-slate-800">
        <blockquote className="twitter-tweet">
          <a href="https://twitter.com/elonmusk/status/1705670347778822601"></a>
        </blockquote>
        <div className="p-3 text-sm text-center text-slate-600 dark:text-slate-300">
          X (Twitter) Post Embed
        </div>
      </div>

      {/* INSTAGRAM */}
      <div className="rounded-xl overflow-hidden shadow-md border border-slate-200 dark:border-slate-800">
        <blockquote
          className="instagram-media"
          data-instgrm-permalink="https://www.instagram.com/p/CyA7i3yMG1K/"
          data-instgrm-version="14"
          style={{ background: "#fff", border: 0, margin: "auto", maxWidth: 540 }}
        ></blockquote>
        <div className="p-3 text-sm text-center text-slate-600 dark:text-slate-300">
          Instagram Post Embed
        </div>
      </div>

      {/* TIKTOK */}
      <div className="rounded-xl overflow-hidden shadow-md border border-slate-200 dark:border-slate-800">
        <blockquote
          className="tiktok-embed"
          cite="https://www.tiktok.com/@scout2015/video/6718335390845095173"
          data-video-id="6718335390845095173"
          style={{ maxWidth: "605px", minWidth: "325px" }}
        >
          <section> </section>
        </blockquote>
        <script async src="https://www.tiktok.com/embed.js"></script>
        <div className="p-3 text-sm text-center text-slate-600 dark:text-slate-300">
          TikTok Video Embed
        </div>
      </div>
    </div>
  );
}
